/**
 * Reason for rejecting a declared payment, in place of window.prompt.
 * The reason is required: the diner reads it before declaring again.
 */

import { useState } from 'react';

import { labels } from '../labels.js';
import { Modal } from './Modal.js';

interface RejectPaymentDialogProps {
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

export function RejectPaymentDialog({ onConfirm, onCancel }: RejectPaymentDialogProps) {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);
  const missing = reason.trim().length === 0;

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setTouched(true);
    if (!missing) onConfirm(reason.trim());
  };

  return (
    <Modal
      title={labels.payment.rejectTitle}
      description={labels.payment.rejectDescription}
      onClose={onCancel}
      onSubmit={submit}
      footer={
        <>
          <button type="button" className="btn-ghost" onClick={onCancel}>{labels.cancel.abort}</button>
          <button type="submit" className="btn-danger btn-danger--solid">{labels.payment.reject}</button>
        </>
      }
    >
      <div className="field">
        <label htmlFor="reject-reason" className="field-label">{labels.payment.rejectPrompt}</label>
        <textarea
          id="reject-reason"
          className="input"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          aria-invalid={touched && missing}
          autoFocus
        />
        {touched && missing && <p role="alert" className="field-error">{labels.payment.rejectRequired}</p>}
      </div>
    </Modal>
  );
}
